import { API_ROUTES } from './constants';
import {
  getPendingCategoryOperations,
  removePendingCategoryOperation,
  PendingCategoryOperation,
  markCategoryOperationFailed,
} from './categoriesIndexedDBUtils';

export async function syncPendingCategories(apiClient: {
  post: <T>(url: string, body: unknown) => Promise<T>;
  patch: <T>(url: string, body: unknown) => Promise<T>;
  delete: (url: string) => Promise<unknown>;
}): Promise<{ synced: number; failed: number }> {
  const pendingOps = await getPendingCategoryOperations();
  let synced = 0;
  let failed = 0;

  for (const op of pendingOps) {
    if (op.status === 'failed') {
      continue;
    }
    try {
      await syncOperation(op, apiClient);
      await removePendingCategoryOperation(op.id);
      synced += 1;
    } catch (error) {
      console.warn('Failed to sync category op', op, error);

      const errorMessage =
        error instanceof Error ? error.message : String(error);
      if (
        errorMessage.includes('already exists') ||
        errorMessage.includes('400')
      ) {
        await markCategoryOperationFailed(op.id);
      }
      failed += 1;
    }
  }

  return { synced, failed };
}

async function syncOperation(
  op: PendingCategoryOperation,
  apiClient: {
    post: <T>(url: string, body: unknown) => Promise<T>;
    patch: <T>(url: string, body: unknown) => Promise<T>;
    delete: (url: string) => Promise<unknown>;
  },
) {
  switch (op.type) {
    case 'create':
      await apiClient.post(API_ROUTES.CATEGORY, op.payload);
      break;
    case 'update':
      await apiClient.patch(
        `${API_ROUTES.CATEGORY}/${op.payload.categoryId}`,
        op.payload.data,
      );
      break;
    case 'delete':
      await apiClient.delete(`${API_ROUTES.CATEGORY}/${op.payload.categoryId}`);
      break;
  }
}
